import React = require('react');
import { ButtonType,ButtonWidget } from '@tableau/widgets';
import { style } from 'typestyle';

import { ContentDraftStatus } from '../../ts/ServerApi/types/ContentDraft';
import { TooltipDraftIndicatorStyles } from '../styles/DraftStyles';
import { DraftTags } from './DraftTags';

export interface TooltipDraftIndicatorProps {
  indicatorText: () => string;
  linkText: () => string;
  handleAction: () => void;
  hideEditingLink?: boolean;
}

export class TooltipDraftIndicator extends React.PureComponent<TooltipDraftIndicatorProps> {
  public render() {
    return (
      <div data-tb-test-id="draft-edits-indicator" className={TooltipDraftIndicatorStyles.ContainerStyle}>
        {this.renderDraftTag()}
        <div className={TooltipDraftIndicatorStyles.TextStyle}>
          {`${this.props.indicatorText()} `}
          {!this.props.hideEditingLink && this.renderEditingLink()}
        </div>
      </div>
    );
  }

  private renderEditingLink(): JSX.Element {
    return (
      <ButtonWidget
        className={style(TooltipDraftIndicatorStyles.buttonHoverStyle)}
        testId="draft-continue-editing"
        title={this.props.linkText()}
        buttonType={ButtonType.LowEmphasis}
        tabIndex={0}
        handleClick={this.props.handleAction}
        style={TooltipDraftIndicatorStyles.InlineButtonStyles}
      >
        {this.props.linkText()}
      </ButtonWidget>
    );
  }

  private renderDraftTag(): JSX.Element {
    // only the "draft" tag should be rendered in the tooltip
    let draftStatus = ContentDraftStatus.unpublishedchanges;
    return <DraftTags draftStatus={draftStatus} />;
  }
}

